// Comments Analysis Page - Unified Multi-Platform Sentiment Analysis
import UnifiedCommentAnalysis from "./UnifiedCommentAnalysis";

const CommentsAnalysisPage = ({ lang = "en" }) => {
  return (
    <div className="space-y-6" data-testid="comments-analysis-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold font-heading tracking-tight">
          {lang === "ko" ? "댓글 감성 분석" : lang === "zh" ? "评论情感分析" : "Comment Sentiment Analysis"}
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          {lang === "ko"
            ? "플랫폼별 게시물 댓글을 수집하고 AI로 감성, 언어, 키워드를 분석합니다"
            : lang === "zh"
            ? "按平台收集帖子评论，并使用AI分析情感、语言和关键词"
            : "Collect post comments by platform and analyze sentiment, language, and keywords with AI"}
        </p>
      </div>
      <UnifiedCommentAnalysis lang={lang} />
    </div>
  );
};

export default CommentsAnalysisPage;
